<script setup lang="ts">
defineProps({
  blok: Object,
});

const localePath = useLocalePath();
</script>

<template>
  <section class="section">
    <UiContainer max-width="max-w-8xl">
      <div class="bg-[#FFC14A] rounded-[30px] p-12 relative overflow-hidden">
        <img
          v-motion-fade-visible-once
          src="https://a.storyblok.com/f/291812700015950/246x627/a10cc9f541/home-questions-01.svg"
          alt="Questions"
          class="absolute top-0 -left-20 z-0 max-[1281px]:hidden"
        />
        <img
          v-motion-fade-visible-once
          src="https://a.storyblok.com/f/291812700015950/349x589/c399aa4bdc/home-questions-02.svg"
          alt="Questions"
          class="absolute top-0 -right-20 max-[1281px]:hidden"
        />
        <img
          v-motion-fade-visible-once
          src="https://a.storyblok.com/f/291812700015950/482x437/8df035df1f/home-questions-03.svg"
          alt="Questions"
          class="absolute bottom-0 -left-20 z-0 max-[1281px]:hidden"
        />
        <img
          v-motion-fade-visible-once
          src="https://a.storyblok.com/f/291812700015950/460x431/a63b3a0640/home-questions-04.svg"
          alt="Questions"
          class="absolute bottom-0 -right-20 max-[1281px]:hidden"
        />
        <UiContainer max-width="max-w-5xl" class="relative z-1 mb-20">
          <header
            class="text-center whitespace-break-spaces [&>h3]:font-londrina-solid [&>h3]:fs-7xl [&>h3]:text-chsc-indigo-500 [&>h3>strong]:fs-8xl [&>h3>strong]:text-white [&>h3]:mb-9 [&>p]:font-eb-garamond [&>p]:fs-2xl [&>p]:text-chsc-indigo-500 [&>h5]:font-londrina-solid [&>h5]:fs-5xl [&>h5]:text-chsc-indigo-500 [&>h5]:mt-9"
          >
            <StoryblokRichText :doc="blok?.header" />
          </header>
        </UiContainer>
        <div class="relative z-1 flex flex-wrap -m-8 justify-center">
          <template v-for="(question, index) in blok?.questions" :key="question._uid">
            <div class="w-1/3 p-8 max-[1281px]:w-1/2 max-[769px]:w-full">
              <div
                v-motion-slide-visible-once-top
                class="bg-chsc-indigo-500 rounded-[30px] p-12 flex flex-col items-center justify-around min-h-full space-y-6"
              >
                <div
                  class="text-white w-[36px] h-[36px] rounded-full flex items-center justify-center font-eb-garamond border border-white fs-xl font-bold"
                >
                  {{ index + 1 }}
                </div>
                <div class="text-white text-center font-montserrat font-bold fs-xl">
                  <StoryblokRichText :doc="question.question" />
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </UiContainer>
  </section>
</template>
